module.exports = __webpack_public_path__ + "i18n/es_ef9d7f1f4ebb57dd3b2a50b60bfbff3f.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 153